import * as React from "react";
import { withPrefix } from "gatsby-link";
import styled from "styled-components";
import { rem } from 'polished';

import coverImg from "./cover-img.jpg";
import coverVideoWebm from "./videos/cover.webm";
import coverVideoMp4 from "./videos/cover.mp4";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #000;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
`;

const Col = styled.div`
  height: inherit;
  flex-basis: 50%;
`

const LeftCol = Col.extend`
  padding-left: calc(11% + 15px);
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Title = styled.div`
  font-size: ${rem('38px')};
`;

const SubTitle = styled.div`
`;

const SecondSection = (props: any) => (
  <Wrapper>
    <LeftCol>
      <Title>iTaksi</Title>
      <SubTitle>
        iTaksi is the new application for online taxi requests. Application’s UI and UX designs are made by us. We also designed a device for the cars. So drivers can use the device to respond taxi requests.
      </SubTitle>
    </LeftCol>
    <Col>
      <Title>iTaksi</Title>
    </Col>
  </Wrapper>
);

export default SecondSection;



// WEBPACK FOOTER //
// ./src/components/HomeSection/SecondSection.tsx